export default {"src":"/_next/static/media/Ministry.4afb68a7.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};